// src/analytics.js
/**
 * Thin wrapper around the GA4 gtag.js snippet loaded in public/index.html
 * (see the <script> block that calls gtag("config", "G-0JQELVDSPH")).
 *
 * Safe to call even if gtag hasn't loaded yet - e.g. an ad-blocker stripped
 * the script tag, or window.gtag doesn't exist yet in tests/SSR.
 */
import { trackFunnel } from "./utils/funnel";

export const trackEvent = (eventName, params = {}) => {
  // Every GA event is mirrored into our own journey log (admin "User Journey"),
  // which - unlike gtag - isn't lost to ad blockers.
  trackFunnel(eventName, { props: params });

  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", eventName, params);
};

export const referralProps = (code) => ({
  is_referred: !!code,
  ...(code ? { referrer_code: code } : {}),
});
